import { render, staticRenderFns } from "./restart-btn.vue?vue&type=template&id=55f94b84"
import script from "./restart-btn.vue?vue&type=script&lang=js"
export * from "./restart-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports